module.exports = __webpack_public_path__ + "img/chrome12.d5f4316f.png";